module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2361d11ac88b5b0b2f2f2972e98aec10.png";